import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import NonFlexingContainer from '../../../../../Layouts/NonFlexingContainer'
import { SpacingProps } from '../../../../../utils/styling/StylingHelper'
import LabelFont from '../../../../../Theme/Fonts/Label'

type WinningAverageProps = {
    label: string
    icon: 'average' | 'darts-throws' | 'darts-winner'
} & Pick<SpacingProps, 'spaceX' | 'spaceLeft' | 'spaceRight'>

const WinningAverage: FunctionComponent<WinningAverageProps> = ({
    label,
    icon,
    spaceRight,
    spaceLeft,
    spaceX,
}) => (
    <NonFlexingContainer
        centerHorizontal
        spaceX={spaceX}
        spaceRight={spaceRight}
        spaceLeft={spaceLeft}
        paddingTop={2}
    >
        <Grid noExpand paddingBottom={2}>
            <FontelloIcon name={icon} fontSize="FS12" color="onyx-5" />
        </Grid>
        <LabelFont textAlign="center" color="onyx-5">
            {label}
        </LabelFont>
    </NonFlexingContainer>
)

export default WinningAverage
